import React from 'react';
import { Dialog, Box, Stack, IconButton } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { StatusChip } from '../../../../../../component/listing';
import DataTable from "../../../../../../component/DataTable";
import { CLAIM_STATUS_TONE } from "../claimColumns";
import { tokens } from '../../../../../../theme';

import { displayFont } from "../../../../../../theme";
const money = (n) => `₹ ${Number(n || 0).toLocaleString("en-IN")}`;

function PendingExpenseDialog({ open, onClose, data = [], pendingAmount }) {
  return (
    <Dialog open={open} onClose={onClose}
      PaperProps={{ sx: { width: "min(54rem, 94vw)", maxWidth: "none", borderRadius: "12px", p: "1.5rem" } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: "1.25rem" }}>
        <Box sx={{ fontFamily: displayFont, fontSize: "1.25rem", fontWeight: 600, color: tokens.text }}>Pending for verification</Box>
        <IconButton aria-label="Close" size="small" onClick={onClose}><CloseOutlinedIcon fontSize="small" /></IconButton>
      </Stack>

      <DataTable
        rows={data || []}
        empty={{ title: "Nothing pending", description: "No expense claims are awaiting verification." }}
        tableSx={{ width: "100%", tableLayout: "fixed" }}
        columns={[
          { key: "date", label: "Date", render: (r) => r.date },
          { key: "employee", label: "Employee", cellSx: { fontWeight: 600 }, render: (r) => r.employeeName },
          { key: "category", label: "Category", render: (r) => r.category || "—" },
          { key: "amount", label: "Amount", align: "right", render: (r) => money(r.amount) },
          { key: "status", label: "Status", render: (r) => <StatusChip label={r.status} tone={CLAIM_STATUS_TONE[r.status]} /> },
        ]}
      />

      <Stack direction="row" alignItems="center" justifyContent="space-between"
        sx={{ mt: "1.25rem", p: "1rem 1rem", borderRadius: "10px", background: tokens.surfaceSubtle }}>
        <Box sx={{ fontSize: "0.9375rem", fontWeight: 500, color: tokens.text }}>Total amount under review</Box>
        <Box sx={{ fontSize: "1rem", fontWeight: 600, color: tokens.danger }}>{money(pendingAmount)}</Box>
      </Stack>
    </Dialog>
  );
}

export default PendingExpenseDialog;
